import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'titleCase',
})
export class TitleCasePipe implements PipeTransform {
    transform(value?: string | null): string {
        if (!value) {
            return '';
        }

        return value.replace(/[A-Za-z]+\s*/g, (val) => {
            if (/^[Ii]+$/.test(val)) {
                return val.toUpperCase();
            } else {
                return val[0].toUpperCase() + val.substr(1).toLowerCase();
            }
        });
    }
}
